import {
    FETCH_HOME_WIDGET_FULFILLED,
    FETCH_HOME_WIDGET_PENDING,
    FETCH_HOME_WIDGET_REJECTED
} from '../constants/homeWidget';

const initialState = {
    error: [],
    pending: true,
    homeWidget: ''
}

export const homeWidget = (state = initialState, action) => {
    switch (action.type) {
        case FETCH_HOME_WIDGET_PENDING:
            return {
                ...state,
                pending: true,
                error: []
            }
        case FETCH_HOME_WIDGET_REJECTED:
            return {
                ...state,
                pending: false,
                error: action.error
            }
        case FETCH_HOME_WIDGET_FULFILLED:
            return {
                ...state,
                pending: false,
                homeWidget: action.response
            }
        default:
            return state
    }
}




// WEBPACK FOOTER //
// ./src/reducers/homeWidget.js